import React from 'react';
import DrawerMenu from 'react-modern-drawer';
import CloseBtn from '../../../assets/images/close-drawer.svg';
import EditBandwidthForm from './EditBandwidthForm';

interface EditBandwidthProps {
  bandwidth: any;
  nearend_name: string;
  nearend_description: string;
  farend_name: string;
  farend_description: string;
  description: string;
  loading: boolean;
  neError: string;
  feError: string;
  open: boolean;
  cancelLoading: boolean;
  portView: boolean;
  onClose: () => void;
  submitEdits: () => void;
  deleteOffNetBandwidth: () => void;
  onFieldChange: (e: any, value: string) => void;
  handleCancelSubscription: (port: any) => void;
}

const EditBandwidthDrawer: React.FC<EditBandwidthProps> = ({
  onClose, cancelLoading, loading, open, handleCancelSubscription, deleteOffNetBandwidth, portView, onFieldChange, nearend_description, nearend_name, bandwidth, submitEdits, neError, feError, farend_description, farend_name, description,
}) => {
  return (
    <DrawerMenu
      enableOverlay
      className="manage-ports-drawer"
      open={open}
      onClose={onClose}
      duration={100}
      direction="right"
    >
      <div
        className="close-drawer-btn"
        onClick={onClose}
      >
        <img src={CloseBtn} alt="Close Drawer" />
      </div>

      <EditBandwidthForm cancelLoading={cancelLoading} handleCancelSubscription={handleCancelSubscription} portView={portView} deleteOffNetBandwidth={deleteOffNetBandwidth} neError={neError} feError={feError} bandwidth={bandwidth} loading={loading} nearend_name={nearend_name} nearend_description={nearend_description} farend_description={farend_description} farend_name={farend_name} submitEdits={submitEdits} onClose={onClose} onFieldChange={onFieldChange} description={description} />
    </DrawerMenu>
  );
};

export default EditBandwidthDrawer;
